import React from "react";
import style from "./Clients2.module.css";
import { useQuery } from "@tanstack/react-query"
import { getClientLogos } from '../../api/containersApi';

export function Clients2({headingText, subText}){

    const { data: clientLogosList, isLoading, isError, refetch } = useQuery({
        queryKey: ['clientLogosList'],
        queryFn: () => (getClientLogos({auth_key: localStorage.getItem('sessionToken')})),
    });

    const featuredObjects = clientLogosList?.filter((imageDetail, index) => {
        return imageDetail?.is_featured === "1";
    })

    const unfeaturedObjects= clientLogosList?.filter((imageDetail, index) => {
        return imageDetail?.is_featured === "0";
    })

    return (
        <div className={style.clients_section} id='clients'>

            <section>
                <h1 className={style.feb_client_heading}>{headingText}</h1>
                <p className={style.feb_client_paragraph}>{subText}</p>
            </section>

            <div className={style.featured_Clients}>
                {
                    featuredObjects?.map((featuredObject, index) => {
                        return <div><img src={featuredObject?.logo} alt="client" /></div>
                    })
                }
            </div>

            <div className={style.logos_container}>

                {/* STRAIGHT DESKTOP-VIEW */}
                <div className={`${style.logos} ${style.desktopView}`}>
                    {
                        isLoading ? <section style={{textAlign: "center", width: "100%", padding: "1rem"}}>Loading Clients...</section> : 
                        <>
                            <div className={style.logos_slide}>
                                {unfeaturedObjects?.map((imageDetail, index) => (                            
                                    <div><img src={imageDetail?.logo} alt='client' /></div>
                                ))}
                            </div>

                            <div className={style.logos_slide}>
                                {unfeaturedObjects?.map((imageDetail, index) => (
                                    <div><img src={imageDetail?.logo} alt='client' /></div>
                                ))}
                            </div>
                        </>
                    }
                </div>

                {/* REVERSE DESKTOP-VIEW */}
                <div className={`${style.logos} ${style.desktopView}`}>
                    {
                        isLoading ? <section style={{textAlign: "center", width: "100%", padding: "1rem"}}>Loading Clients...</section> : 
                        <>
                            <div className={style.logos_slide_R}>
                                {unfeaturedObjects?.slice()?.reverse()?.map((imageDetail, index) => (                            
                                    <div><img src={imageDetail?.logo} alt='client' /></div>
                                ))}
                            </div>

                            <div className={style.logos_slide_R}>
                                {unfeaturedObjects?.slice()?.reverse()?.map((imageDetail, index) => (
                                    <div><img src={imageDetail?.logo} alt='client' /></div>
                                ))}
                            </div>
                        </>
                    }
                </div>

                {/* STRAIGHT NOT-DESKTOP-VIEW */}
                <div className={`${style.logos} ${style.notDesktopView}`}>
                    {
                        isLoading ? <section style={{textAlign: "center", width: "100%", padding: "1rem"}}>Loading Clients...</section> : 
                        <>
                            <div className={style.logos_slide}>
                                {clientLogosList?.map((imageDetail, index) => (                            
                                    <div><img src={imageDetail?.logo} alt='client' /></div>
                                ))}
                            </div>

                            <div className={style.logos_slide}>
                                {clientLogosList?.map((imageDetail, index) => (
                                    <div><img src={imageDetail?.logo} alt='client' /></div>
                                ))}
                            </div>
                        </>
                    }
                </div>

                {/* REVERSE NOT-DESKTOP-VIEW */}
                <div className={`${style.logos} ${style.notDesktopView}`}>
                    {
                        isLoading ? <section style={{textAlign: "center", width: "100%", padding: "1rem"}}>Loading Clients...</section> : 
                        <>
                            <div className={style.logos_slide_R}>
                                {clientLogosList?.slice()?.reverse()?.map((imageDetail, index) => (                            
                                    <div><img src={imageDetail?.logo} alt='client' /></div>
                                ))}
                            </div>

                            <div className={style.logos_slide_R}>
                                {clientLogosList?.slice()?.reverse()?.map((imageDetail, index) => (
                                    <div><img src={imageDetail?.logo} alt='client' /></div>
                                ))}
                            </div>
                        </>
                    }
                </div>

            </div>
        </div>
    )
}